exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order-kanban-column__title[data-v-2a513f45]{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;position:-webkit-sticky;position:sticky;left:0;margin-bottom:10px}.order-kanban-column__nested[data-v-2a513f45]{display:flex;flex-direction:column;background-color:#e1e1e1;padding:6px 10px 0}", ""]);

// exports
